var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicroscope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.63,
    cy: 81.8,
    r: 13.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 142.35,
    y1: 160.43,
    x2: 46.55,
    y2: 160.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.41,85.24a59.42,59.42,0,0,1-18.11,97.48l4.63,14.52H79.49l6.58-15.88A59.68,59.68,0,0,1,62.92,161.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.71,95.65a44.48,44.48,0,0,1-60.64,65.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "131.62 93.64 115.29 122.84 88.29 107.73 128.78 35.33 155.79 50.44 145.55 68.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "110.85 121.18 101.57 137.92 82.91 127.48 92.19 110.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "133.59 36.61 138 28.35 156.67 38.79 152.25 47.05"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscope);
export default __webpack_public_path__ + "static/media/MICROSCOPE.1d91a3d448674236854e201420a52008.svg";
export { ForwardRef as ReactComponent };